import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc5eac5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk_add_cat" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "aucune",
  selected: ""
}, "Aucune", -1))
const _hoisted_3 = { label: "Catégories principales" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { label: "Catégories secondaires" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "mainCats" }
const _hoisted_8 = { class: "editCats" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "editCat" }, " Editer les catégories ", -1))
const _hoisted_10 = { class: "switch" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_12 = {
  key: 0,
  class: "infos"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "aucune",
  selected: ""
}, "Aucune", -1))
const _hoisted_14 = { label: "Catégories principales" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { label: "Catégories secondaires" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "infos"
}
const _hoisted_19 = { style: {"font-weight":"800","margin-right":"10px"} }
const _hoisted_20 = { style: {"margin-right":"10px"} }
const _hoisted_21 = {
  key: 2,
  class: "actions"
}
const _hoisted_22 = { class: "subCategories" }
const _hoisted_23 = {
  key: 0,
  class: "infos"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "aucune",
  selected: ""
}, "Aucune", -1))
const _hoisted_25 = { label: "Catégories principales" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { label: "Catégories secondaires" }
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 1,
  class: "infos"
}
const _hoisted_30 = { style: {"font-weight":"800","margin-right":"10px"} }
const _hoisted_31 = { style: {"margin-right":"10px"} }
const _hoisted_32 = {
  key: 2,
  class: "actions"
}

import { onBeforeMount } from 'vue'
import { ref } from "vue";
import axios from "axios";
import { toast } from 'vue3-toastify';



// variable


export default /*#__PURE__*/_defineComponent({
  __name: 'addCatView',
  setup(__props) {

const categories = ref([]);
const mainCategories = ref([]);
const is_edit = ref(false);

function editCat(categorie) {
    axios.put(process.env.VUE_APP_SERVER_URL + '/categories', { categorie: categorie })
        .then(function () {
            toast.success('Catégorie mise à jour !');
        })
        .catch(function (error) {
            toast.error(error);
        });
}
function showCats(categorie) {
    axios.get(process.env.VUE_APP_SERVER_URL + '/categories/child', {
        params: {
            cat: categorie
        }
    })
        .then(function (response) {
            // handle success
            categories.value = response.data;
            console.log(categories.value[0].childs);
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })


}

function deletCat(id, index) {

    axios.delete(process.env.VUE_APP_SERVER_URL + '/categories', { data: { id: id } })
        .then(function () {
            categories.value.splice(index, 1);
            toast.success('Catégorie supprimée!');

        })
        .catch(function (error) {
            toast.error(error);
        });
}
function addCat(params) {
    axios.post(process.env.VUE_APP_SERVER_URL + '/categories', params)
        .then(function (response) {
            categories.value.push(response.data)
            toast.success('Catégorie ajoutée!');
        })
        .catch(function (error) {
            toast.error(error);
        });
}
onBeforeMount(() => {
    // axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
    //     .then(function (response) {
    //         // handle success
    //         categories.value = response.data;
    //         console.log(categories.value);
    //     })
    //     .catch(function (error) {
    //         // handle error
    //         toast.error(error);
    //     })

    axios.get(process.env.VUE_APP_SERVER_URL + '/categories/main')
        .then(function (response) {
            // handle success
            mainCategories.value = response.data;
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })

})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FormKit, {
      type: "form",
      "submit-label": "Ajouter une catégorie",
      onSubmit: addCat
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          name: "urlImg",
          label: "url"
        }),
        _createVNode(_component_FormKit, {
          name: "titre",
          label: "Titre de catégorie",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          name: "description",
          label: "Description",
          validation: "required"
        }),
        _createVNode(_component_FormKit, {
          type: "select",
          label: "Catégorie parent",
          name: "parent"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("optgroup", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainCategories.value, (mainCategorie, indexChild) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: indexChild,
                  value: mainCategorie._id
                }, _toDisplayString(mainCategorie.titre), 9, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("optgroup", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (categorie, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: categorie._id
                }, _toDisplayString(categorie.titre), 9, _hoisted_6))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("label", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            id: "editCat",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((is_edit).value = $event)),
            type: "checkbox"
          }, null, 512), [
            [_vModelCheckbox, is_edit.value]
          ]),
          _hoisted_11
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainCategories.value, (mainCategorie, index) => {
        return (_openBlock(), _createBlock(_component_FormKit, {
          key: index,
          onClick: ($event: any) => (showCats(mainCategorie)),
          style: {"jusitfy-self":"flex-end","background-color":"#3488ce"},
          type: "button",
          label: mainCategorie.titre
        }, null, 8, ["onClick", "label"]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (categorie, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "categories",
        key: index
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([{ noEdit: !is_edit.value }, "card"])
        }, [
          (is_edit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_FormKit, {
                  type: "text",
                  modelValue: categorie.titre,
                  "onUpdate:modelValue": ($event: any) => ((categorie.titre) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "text",
                  modelValue: categorie.description,
                  "onUpdate:modelValue": ($event: any) => ((categorie.description) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_FormKit, {
                  type: "select",
                  modelValue: categorie.parent,
                  "onUpdate:modelValue": ($event: any) => ((categorie.parent) = $event),
                  name: "parent"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("optgroup", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainCategories.value, (mainCategorie, indexChild) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: indexChild,
                          value: mainCategorie._id
                        }, _toDisplayString(mainCategorie.titre), 9, _hoisted_15))
                      }), 128))
                    ]),
                    _createElementVNode("optgroup", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (childCat, indexChild) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: indexChild,
                          value: childCat._id
                        }, _toDisplayString(childCat.titre), 9, _hoisted_17))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(categorie.titre), 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(categorie.description), 1)
              ])),
          (is_edit.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_FormKit, {
                  onClick: ($event: any) => (editCat(categorie)),
                  style: {"jusitfy-self":"flex-end","background-color":"#3488ce"},
                  type: "button",
                  label: "Editer"
                }, null, 8, ["onClick"]),
                _createVNode(_component_FormKit, {
                  onClick: ($event: any) => (deletCat(categorie._id, index)),
                  style: {"jusitfy-self":"flex-end","background-color":"#f03a5f"},
                  type: "button",
                  label: "Supprimer"
                }, null, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categorie.childs, (children, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([{ noEdit: !is_edit.value }, "card"]),
              key: index
            }, [
              (is_edit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      modelValue: children.titre,
                      "onUpdate:modelValue": ($event: any) => ((children.titre) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      modelValue: children.description,
                      "onUpdate:modelValue": ($event: any) => ((children.description) = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_FormKit, {
                      type: "select",
                      modelValue: children.parent,
                      "onUpdate:modelValue": ($event: any) => ((children.parent) = $event),
                      name: "parent"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_24,
                        _createElementVNode("optgroup", _hoisted_25, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainCategories.value, (mainCategorie, indexChild) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: indexChild,
                              value: mainCategorie._id
                            }, _toDisplayString(mainCategorie.titre), 9, _hoisted_26))
                          }), 128))
                        ]),
                        _createElementVNode("optgroup", _hoisted_27, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (childCat, indexChild) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: indexChild,
                              value: childCat._id
                            }, _toDisplayString(childCat.titre), 9, _hoisted_28))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(children.titre), 1),
                    _createElementVNode("span", _hoisted_31, _toDisplayString(children.description), 1)
                  ])),
              (is_edit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createVNode(_component_FormKit, {
                      onClick: ($event: any) => (editCat(categorie)),
                      style: {"jusitfy-self":"flex-end","background-color":"#3488ce"},
                      type: "button",
                      label: "Editer"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_FormKit, {
                      onClick: ($event: any) => (deletCat(categorie._id, index)),
                      style: {"jusitfy-self":"flex-end","background-color":"#f03a5f"},
                      type: "button",
                      label: "Supprimer"
                    }, null, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})